
import { useState } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: 'William L.',
      role: 'Yelp',
      text: 'I recently had my two prints done here and I am very impressed with the finished result. As soon as the frame picking process started, I was also recommended an inner accent border that added so much to the prints. A very sharp set of eyes at this shop and price point that was reasonable. Customer service was best in the valley in my book. Thanks again for all your help!',
      rating: 5,
    },
    {
      name: 'J. K.',
      role: 'Yelp',
      text: 'Absolutely stellar framing and warm and talented customer service. This is an A+++ rated business among all businesses, not just framing. Brittany is fantastic: friendly, knowledgeable, efficient, precise, charming, and provides quality framing expertise. She is delightful to work with and gives her full attention to ensure she will make the outcome meet with high customer satisfaction. She excels in customer service abilities, communication skills, and professionalism. My framing is beautiful and stunning and was very reasonably priced. Thank you.',
      rating: 5,
    },
    {
      name: 'Rony R.',
      role: 'Yelp',
      text: 'Great customer service. She went above and beyond to help with something that turned out to be very challenging.',
      rating: 5,
    },
  ];

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-16 md:py-24 bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 mb-4 px-4 py-2 border border-[#D4B137] rounded-full">
            <i className="ri-star-fill text-[#D4B137]"></i>
            <p className="text-black text-sm font-medium">Client Experiences</p>
          </div>
          <h3 className="text-3xl md:text-5xl font-serif font-bold text-black">
            Client Reviews
          </h3>
        </div>

        {/* Mobile Carousel */}
        <div className="md:hidden">
          <div className="relative">
            <div className="bg-white rounded-lg p-6 shadow-md">
              <div className="flex gap-1 mb-4">
                {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#D4B137] text-lg"></i>
                ))}
              </div>
              <p className="text-gray-700 text-sm leading-relaxed mb-6 italic">
                "{testimonials[currentIndex].text}"
              </p>
              <div>
                <h4 className="font-bold text-black">{testimonials[currentIndex].name}</h4>
                <p className="text-sm text-gray-600">{testimonials[currentIndex].role}</p>
              </div>
            </div>

            <div className="flex items-center justify-center gap-4 mt-6">
              <button
                onClick={handlePrev}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white shadow-md hover:bg-[#D4B137]/10 transition-all cursor-pointer"
              >
                <i className="ri-arrow-left-s-line text-xl text-[#2E4A3E]"></i>
              </button>
              <div className="flex items-center gap-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                      index === currentIndex
                        ? 'bg-[#D4B137] w-5'
                        : 'bg-[#2E4A3E]/20'
                    }`}
                  />
                ))}
              </div>
              <button
                onClick={handleNext}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white shadow-md hover:bg-[#D4B137]/10 transition-all cursor-pointer"
              >
                <i className="ri-arrow-right-s-line text-xl text-[#2E4A3E]"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Desktop Grid */}
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-6 md:p-8 shadow-md"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#D4B137] text-lg"></i>
                ))}
              </div>
              <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </p>
              <div>
                <h4 className="font-bold text-black">{testimonial.name}</h4>
                <p className="text-sm text-gray-600">{testimonial.role}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
